import React from 'react'
//import { Outlet, Link, NavLink } from "react-router-dom";
//import { useState, useEffect } from "react"
import "98.css";

export default function Artwork({songName}) {

    let artwork;
    if (songName === 'ITAT') {
        artwork = '/images/itatartwork_sml.jpg';
    } else if (songName === 'Midnight') {
        artwork = '/images/midnight artwork final_sml.jpg';
    } else if (songName === 'DON') {
        artwork = '/images/disco on neptune artwork final_sml.jpg';
    } else if (songName === 'TGBH') {
        artwork = '/images/be lucky5_sml.jpg';
    } else if (songName === 'Songs About Love and Money') {
        artwork = '/images/EP Artwork FINAL-sml.jpg';
    }

    return (
        <>

        <img src={artwork} alt="artwork"></img>
        
        </> 
    )
}